export const normalize = (string: string) => {
  if (!string) return string;

  return string
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "") // replace diacritics with their 'base' letter (i.e. é -> e)
    .replace(/\./g, "") // remove periods
    .replace(/ /g, ""); // remove spaces
};
